import React, { useEffect, useState } from 'react';

// One site-wide line for "that didn't work". A page calls flash('…') when an
// action fails instead of silently doing nothing; this shows it at the foot
// of the screen for a few seconds. Mounted once in App.jsx.
const EVENT = 'uf:flash';

export function flash(message) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: message }));
}

export default function FlashNotice() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const onFlash = (e) => setMessage(String(e.detail || ''));
    window.addEventListener(EVENT, onFlash);
    return () => window.removeEventListener(EVENT, onFlash);
  }, []);

  useEffect(() => {
    if (!message) return undefined;
    const t = setTimeout(() => setMessage(''), 4500);
    return () => clearTimeout(t);
  }, [message]);

  return (
    <div role="status" aria-live="polite" className="pointer-events-none fixed inset-x-0 bottom-6 z-[150] flex justify-center px-4">
      {message && (
        <p className="m-0 max-w-[90vw] rounded-full bg-press-ink px-4 py-2 text-center text-sm font-semibold text-press-paper shadow-lg">
          {message}
        </p>
      )}
    </div>
  );
}
